<template>
<div>
  <b-loading :is-full-page="false" :active="!projects" v-if="loading" />
  <div class="page-wrapper content-wrapper">

    <div class="box error" v-if="error">
      <h2> {{ $t('error') }} </h2>
      <p>{{ $t('unexpected-error-info-message') }}</p>
    </div>
    
    <div class="panel" v-else-if="projects" 
    >
      <div style="width: 100%;">
        <div class="content-title-wrapper">
          <label class="hierarchy-label" >
            <span v-if="!currentWorklist.builtin">{{$t('worklist')}} ></span>
            <span>{{ currentWorklist.name }}</span>
          </label>
          <div class="table-tool-icon-bar">
            <!-- <i v-if="canAddImage" class="fas fa-plus icon-style" @click="openAddProjectModal"></i> -->
            <!-- @click="confirmDeletion()" v-show="checkedRows && checkedRows.length > 0"  -->
            <i v-if="canAddImage" class="fas fa-trash-alt icon-style" :class="{ 'icon-disabled': !hasCheckedRows }" @click="hasCheckedRows && removeSelectedProjectsFromWorklist()"></i>
            <i v-if="canAddImage" class="fas fa-ban icon-style" :class="{ 'icon-disabled': !hasCheckedRows }" @click="hasCheckedRows && clickDeleteCase()"></i>
          </div>
        </div>

        <div>
          <!--  class="panel-block" -->
          <cytomine-lazy-table
            v-if="Object.keys(projects).length > 0"
            :collection="projects"
            :detailed="false"
            :checkable="canAddImage"
            :checkedRows.sync="checkedRows"
            :revision="revision"
            :sort="'created'"
            :order="'desc'"
          >
            <template #default="{row: project}">
              <b-table-column field="name" :label="$t('name-uppercase')" sortable width="8%">
                <router-link :to="{ path: `/worklist/${$route.params.sortPropWorklist}-${$route.params.idWorklist}/case/${project.id}`, query: { tab: 'images' }}">
                  {{ project.name }}
                </router-link>
              </b-table-column>
              <b-table-column field="created" :label="$t('created-uppercase')" sortable width="12%">
                <router-link :to="{ path: `/worklist/${$route.params.sortPropWorklist}-${$route.params.idWorklist}/case/${project.id}`, query: { tab: 'images' }}">
                  {{ formattingTimestamp(project.created) }}
                </router-link>
              </b-table-column>
              <b-table-column field="images" :label="$t('images-uppercase')" sortable width="8%">
                <router-link :to="{ path: `/worklist/${$route.params.sortPropWorklist}-${$route.params.idWorklist}/case/${project.id}`, query: { tab: 'images' }}">
                  {{ project.images }}
                </router-link>
              </b-table-column>
              <b-table-column field="status" :label="$t('status-uppercase')" sortable width="10%">
                <router-link :to="{ path: `/worklist/${$route.params.sortPropWorklist}-${$route.params.idWorklist}/case/${project.id}`, query: { tab: 'images' }}">
                  <!-- {{ project.status }} -->
                    {{ getStatusName(project.status) }}
                </router-link>
              </b-table-column>
              <b-table-column field="patient" :label="$t('patient-uppercase')+' '+$t('name-uppercase')" sortable width="12%">
                <router-link :to="{ path: `/worklist/${$route.params.sortPropWorklist}-${$route.params.idWorklist}/case/${project.id}`, query: { tab: 'images' }}">
                  {{ project.blindmode ? $t('anonymized') : project.patient }}
                </router-link>
              </b-table-column>
              <b-table-column field="assigneeName" :label="$t('assignee-uppercase')" sortable width="12%">
                <router-link :to="{ path: `/worklist/${$route.params.sortPropWorklist}-${$route.params.idWorklist}/case/${project.id}`, query: { tab: 'images' }}">
                  {{ project.blindmode ? $t('anonymized') : project.assigneefirstname + ' ' + project.assigneelastname }}
                </router-link>
              </b-table-column>
              <b-table-column field="bench" :label="$t('bench-uppercase')" sortable width="14%">
                <router-link :to="{ path: `/worklist/${$route.params.sortPropWorklist}-${$route.params.idWorklist}/case/${project.id}`, query: { tab: 'images' }}">
                  {{ project.bench }}
                </router-link>
              </b-table-column>
              <b-table-column field="part" :label="$t('anatomic-site-uppercase')" sortable width="14%">
                <router-link :to="{ path: `/worklist/${$route.params.sortPropWorklist}-${$route.params.idWorklist}/case/${project.id}`, query: { tab: 'images' }}">
                  {{ project.part }}
                </router-link>
              </b-table-column>
              
              <!-- TODO: 현재 계정 ID가 권한의 assignee 인 경우에만 표시  v-if="currentUser.adminByNow" -->
              <b-table-column field="editButton"  label="" width="10%">
                <div class="display-flex-row" >
                  <i class="fas fa-pen icon-style" :disabled="project.blindmode" @click="openEditCaseModal(project)"></i>
                  <i class="fas fa-list-ul icon-style" @click="moveToCaseInfo(project.id)"></i>
                  <i v-if="canAddImage" class="fas fa-trash-alt icon-style" @click="clickRemoveCaseFromWorklist(project)"></i>
                </div>
              </b-table-column>
            </template>

            <template #empty>
              <div class="content has-text-grey has-text-centered">
                <p>{{$t('no-project')}}</p>
              </div>
            </template>
          </cytomine-lazy-table>
        </div>
      </div>
    </div>
  </div>
  <!-- :worklist="updateStatusListFromWorklists()"  -->
  <add-project-to-worklist-modal v-if="projects && projects._data" :active.sync="addProjectToWorklistModal" :existProjects="projects._data" :revision.sync="revision" />
  <add-project-modal :active.sync="createProjectModal" :ontologies="ontologies" />
  <edit-project-modal :active.sync="isOpenEditCaseModal" :case="selectedCase" :revision.sync="revision" />
  <add-worklist-modal 
    :active.sync="worklistModal" 
    :mode="worklistModalMode"
    :worklist="currentWorklist"
    @renamed="handleWorklistRenamed"
    @deleted="handleWorklistDeleted"
  />

  <div v-if="canAddImage" class="floating-add-button" @click="addProjectToWorklistModal = true" >
    <i class="fas fa-plus"></i>
  </div>

</div>
</template>
  
<script>
import {WorklistCollection, WorklistProject, WorklistProjectCollection, ProjectCollection} from 'cytomine-client';
import dayjs from 'dayjs';

import AddProjectToWorklistModal from './AddProjectToWorklistModal.vue';
import AddWorklistModal from './AddWorklistModal.vue';
import EditProjectModal from './EditProjectModal.vue';
import CytomineLazyTable from '@/components/utils/CytomineLazyTable';
import {sync, get} from '@/utils/store-helpers';
import AddProjectModal from '../project/AddProjectModal';
// import projectModuleModel from '@/store/modules/project';
import DefaultWorklist from '../../enums/DefaultWorklist';

export default {
  name: 'workslists-page',
  components: {
    CytomineLazyTable,
    AddProjectToWorklistModal,
    AddProjectModal,
    EditProjectModal,
    AddWorklistModal,
  },
  data() {
    return {
      error: false,
      loading: true,

      addProjectToWorklistModal: false,
      isOpenEditCaseModal: false,
      selectedCase: {},

      worklistModal: false,
      worklistModalMode: 'add',

      projects: [],
      ontologies: [],
      availableTags:[],
      checkedRows: [],
      revision: 0,

      createProjectModal: false,
    };
  },
  watch: {
    // revision이 변경되면(즉, 모달에서 저장이 완료되면) 목록을 다시 불러옵니다.
    revision() {
      this.fetchProjects();
    },
    checkedRows(newVal) {
      console.log('선택된 항목:', newVal);
    }
  },
  // 동일한 컴포넌트에서 라우트 파라미터만 변경될 때 호출됨
  async beforeRouteUpdate(to, from, next) {
    // 라우트 파라미터가 변경될 때마다 워크리스트 정보 갱신
    if (to.params.sortPropWorklist && to.params.idWorklist) {
      await this.loadWorklistData(to.params.sortPropWorklist, to.params.idWorklist);
    }
    next();
  },
  computed: {
    searchString: sync('listProjects/searchString', {debounce: 500}),
    currentUser: get('currentUser/user'),
    // project: get('currentProject/project'),
    currentWorklist() {
      return this.$store.getters['worklist/getCurrentWorklist'];
    },
    canAddImage() {
      return !this.currentUser.guestByNow && this.$route.params.sortPropWorklist==='id';
    },
    canManageWorklist() {
      // Can manage (rename/delete) only custom worklists, not built-in status worklists
      return !this.currentUser.guestByNow && this.$route.params.sortPropWorklist==='id';
    },
    hasCheckedRows() {
      return this.checkedRows && this.checkedRows.length > 0;
    },
  },
  methods: {
    async loadWorklistData(sortWorklist, idWorklist) {
      try {
        let defaultInfo = await ProjectCollection.fetchDefaultInfo(idWorklist, null);

        if (sortWorklist == 'id') {
          this.$store.commit('worklist/setWorklist', {id: idWorklist, name: defaultInfo.worklistName});
        }
        else if (sortWorklist == 'status') {
          this.$store.commit('worklist/setDefaultWorklist', {id: idWorklist});
        }

        this.fetchProjects();
      }
      catch (error) {
        console.error('워크리스트 데이터 로드 실패:', error);
        this.error = true;
      }
    },
    openEditCaseModal(project) {
      if (project.blindmode) {
        this.$notify({type: 'error', text: this.$t('notif-error-not-able-edit-at-blind-mode')});
        return;
      }
      this.selectedCase = project;
      this.isOpenEditCaseModal = true;
    },
    // async loadProject() {
    //   try {
    //     if (!this.$store.state.projects[this.idProject]) { // module does not exist yet
    //       this.$store.registerModule(['projects', this.idProject], projectModuleModel);
    //     }
    //     await this.$store.dispatch('currentProject/loadProject', this.idProject);
    //     this.loading = false;
    //   }
    //   catch (error) {
    //     console.log(error);
    //     if (error.response && error.response.status === 403) {
    //       this.permissionError = true;
    //     }
    //     else {
    //       this.notFoundError = true;
    //     }
    //   }
    // },

    openAddProjectModal() {
      this.createProjectModal = true;
    },
    formattingTimestamp(timestamp) {
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
    },
    async fetchProjects() {
      if (!this.currentWorklist || !this.currentWorklist.id) return;

      this.loading = true;
      this.error = false;
      try {
        let data;
        // worklistId 기반으로 관련 프로젝트 가져오기
        if (this.currentWorklist.builtin) {
          data = await WorklistProjectCollection.fetchAll({ filterKey: 'status', filterValue: this.currentWorklist.id });
        }
        else {
          data = await WorklistProjectCollection.fetchAll({ filterKey: 'worklist', filterValue: this.currentWorklist.id });
        }
        this.projects = data;
      }
      catch (error) {
        console.error('프로젝트 불러오기 실패:', error);
        this.error = true;
        this.projects = [];
      }
      finally {
        this.loading = false;
      }
    },

    async projectCollection() {
      let data = await WorklistCollection.fetchAll({filterKey: 'user', filterValue: this.currentUser.id});
      return data;
    },

    // updateStatusListFromWorklists(worklists) {
    //   // worklists 배열이 { id, name, ... } 형태라고 가정
    //   // this.statusList = worklists.map(item => ({ name: item.name, projectCount: item.projectCount }));
    //   this.statusList = worklists;
    // },
    async deleteProjectFromWorklist(projectId) {
      let data = await WorklistProject.deleteProjectToWorklist(this.currentWorklist.id, projectId);
      console.log(data);
    },
    async deleteProjects() {
      const targets = this.checkedRows || [];

      if (!targets.length) return;

      let successCount = 0;
      let failCount = 0;

      try {
        const promises = targets.map(async (project) => {
          try {
            this.$store.unregisterModule(['projects', project.id]);
            await project.delete();
            successCount++;
          }
          catch (e) {
            failCount++;
            console.error(`삭제 실패: ${project.name}`, e);
          }
        });
        await Promise.all(promises);

        this.revision++;
        this.$root.$eventBus.$emit('refreshWorklist');

        // notify 통합 처리
        if (failCount === 0) {
          this.$notify({
            type: 'success',
            text: this.$t('notif-success-project-deletion', {
              projectName: `${successCount} cases`
            })
          });
        }
        else {
          this.$notify({
            type: 'warning',
            text: `성공: ${successCount}개, 실패: ${failCount}개 삭제`
          });
        }
      }
      catch (error) {
        this.$notify({
          type: 'error',
          text: this.$t('notif-error-project-deletion')
        });
      }
    },
    async clickRemoveCaseFromWorklist(project) {
      this.$buefy.dialog.confirm({
        title: this.$t('delete-case'),
        message: this.$t('confirm-remove-case', {caseName: project.name}),
        type: 'is-danger',
        confirmText: this.$t('button-confirm'),
        cancelText: this.$t('button-cancel'),
        onConfirm: () => this.removeCaseFromWorklist(project)
      });
    },
    async removeCaseFromWorklist(project) {
      try {
        await this.deleteProjectFromWorklist(project.id);
        
        this.$notify({
          type: 'success',
          text: this.$t('notif-success-remove-selected-case')
        });
        this.revision++;

        // Emit event to refresh sidebar worklist count
        this.$root.$eventBus.$emit('refreshWorklist');
      }
      catch (error) {
        console.error(error);
        this.$notify({
          type: 'error',
          text: this.$t('notif-error-remove-selected-case')
        });
      }
    },
    // async fetchWorklists() {
    //   let defaultInfo = await ProjectCollection.fetchDefaultInfo(this.$route.params.idWorklist, null);
    //   return defaultInfo;

    //   // try {
    //   //   const data = await WorklistCollection.fetchAll({
    //   //     filterKey: 'user',
    //   //     filterValue: this.currentUser.id
    //   //   });

    //   //   // 반복하면서 각 워크리스트를 store에 저장 (이름과 프로젝트 정보)
    //   //   data.collection.forEach(worklist => {
    //   //     this.$store.commit('worklist/setWorklist', {
    //   //       name: worklist.name,
    //   //       projects: [] // 아직 프로젝트는 따로 API로 받아야 함 (현재는 이름만 저장)
    //   //     });
    //   //   });

    //   //   console.log('[Worklists Loaded]', data.collection);
    //   // }
    //   // catch (error) {
    //   //   console.error('[Worklist fetch error]', error);
    //   // }
    // },
    moveToCaseInfo(idCase) {
      this.$router.push({
        path: `/worklist/${this.$route.params.sortPropWorklist}-${this.$route.params.idWorklist}/case/${idCase}`,
        query: { tab: 'information' }
      });
    },
    getStatusName(statusId) {
      return DefaultWorklist[statusId];
    },
    async removeSelectedProjectsFromWorklist() {
      let selectedNames = this.checkedRows.map(row => `- ${row.name}`).join('<br>');

      this.$buefy.dialog.confirm({
        title: this.$t('confirm-deletion'),
        message: this.$t('confirm-remove-selected-cases', {caseName: selectedNames}),
        type: 'is-danger',
        confirmText: this.$t('button-confirm'),
        cancelText: this.$t('button-cancel'),
        onConfirm: () => this.deleteItem()
      });
    },
    async deleteItem() {
      try {
        const promises = this.checkedRows.map(project => {
          return this.deleteProjectFromWorklist(project.id);
        });
        await Promise.all(promises);

        this.$notify({
          type: 'success',
          text: this.$t('notif-success-remove-selected-case')
        });
        this.revision++;

        // Emit event to refresh sidebar worklist count
        this.$root.$eventBus.$emit('refreshWorklist');
      }
      catch (error) {
        console.error(error);
        this.$notify({
          type: 'error',
          text: this.$t('notif-error-remove-selected-case')
        });
        this.revision++;
      }
    },
    openRenameWorklistModal() {
      this.worklistModalMode = 'rename';
      this.worklistModal = true;
    },

    openDeleteWorklistModal() {
      this.worklistModalMode = 'delete';
      this.worklistModal = true;
    },

    async handleWorklistRenamed(updatedWorklist) {
      // Update the current worklist in store
      this.$store.commit('worklist/setWorklist', {
        id: updatedWorklist.id, 
        name: updatedWorklist.name
      });
    },
    async handleWorklistDeleted() {
      // The modal already handles navigation to status-1
      // Nothing more needed here
    },
    async clickDeleteCase() {
      this.$buefy.dialog.confirm({
        title: this.$t('delete-case'),
        message: this.$t('delete-case-confirmation-message'),
        type: 'is-danger',
        confirmText: this.$t('button-confirm'),
        cancelText: this.$t('button-cancel'),
        onConfirm: () => this.deleteProjects()
      });
    }
  },
  async created() {
    this.loading = true;
    
    // 초기 로드
    const sortWorklist = this.$route.params.sortPropWorklist;
    const idWorklist = this.$route.params.idWorklist;

    const worklistHierarchy = {sortPropWorklist: sortWorklist, idWorklist: idWorklist};
    localStorage.setItem('worklistHierarchy', JSON.stringify(worklistHierarchy));

    if (sortWorklist && idWorklist) {
      await this.loadWorklistData(sortWorklist, idWorklist);
    }
    
    this.loading = false;
  }
};

</script>




<style scoped lang="scss">
.page-wrapper {
  vertical-align: middle !important;
  height: 100%;
}
.content-wrapper {
  padding: 0 2.5%;
  position: relative;
  min-height: 100%;

  overflow: hidden;
}

.content-title-wrapper {
  height: 75px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.filter-wrapper {
  border: 1px solid #cccccc;
}

.worklist-info-wrapper {
  border: 1px solid #cccccc;
  min-width: 500px;
}

.panel {
  display: flex;
  flex-direction: row;
}


.hierarchy-label {
  margin: 1rem 0px;
  font-size: 1.3rem;
  color: #4A4847;
}

.table-tool-icon-bar {
  height: 40px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: anchor-center;
}

.icon-style {
  cursor: pointer;
  margin-right: 10px;
  padding: 10px;
}

.icon-disabled {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}

.floating-add-button {
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 80px;
  height: 80px;

  background-color: #009BDB;
  border-radius: 50%;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  cursor: pointer;
}

.floating-add-button i {
  color: #fff;
  font-size: 30px;
}

.display-flex-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

</style>
